//@getters
import { GetterTree } from "vuex";

interface fileManagementState {
  fileManagement: boolean;
  resource: string;
  resource_id: string;
  attachment_temp_code: Array<object>;
}

export const getters: GetterTree<any, fileManagementState> = {};
